<template>
  <div v-wave class="back-button" @click="click">
    <i :class="['pi', icon]" />
  </div>
</template>

<script lang="ts" setup>
import { Capacitor } from '@capacitor/core';

const props = defineProps({
  icon: {
    type: String,
    default: 'pi-angle-left'
  },
  insidePage: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits(['clickedFloatingButton']);

const click = () => {
  emit('clickedFloatingButton');
};

const top = Capacitor.getPlatform() === 'ios' ? (props.insidePage ? '1.75rem' : '3.75rem') : '1rem';

</script>

<style scoped>

.back-button {
  position: absolute;
  top: v-bind(top);
  left: 1rem;
  color: black;
  box-shadow: rgba(17, 12, 46, 0.35) 0 24px 90px 0;
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  z-index: 100;
  background: white;
}

</style>
